import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../api/client';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const { setSession } = useAdminAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await api.adminLogin(email, password);
      setSession(res);
      navigate('/admin/emails');
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Login failed';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDF8F5] py-12">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl p-8 shadow-lg">
          <div className="mb-6">
            <h1 className="font-serif text-3xl font-semibold text-[#3D3D3D]">Admin Login</h1>
            <p className="font-sans text-sm text-[#3D3D3D]/70 mt-2">
              Sign in to manage subscription email templates.
            </p>
          </div>

          {error && (
            <div className="mb-4 rounded-xl border border-[#D4A5A5]/40 bg-[#D4A5A5]/10 px-4 py-3 font-sans text-sm text-[#3D3D3D]">
              {error}
            </div>
          )}

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-sans text-sm text-[#3D3D3D] mb-2 block">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-xl border border-gray-200 font-sans"
                placeholder="admin@example.com"
              />
            </div>

            <div>
              <label className="font-sans text-sm text-[#3D3D3D] mb-2 block">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-xl border border-gray-200 font-sans"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={submitting || !email.trim() || !password.trim()}
              className="w-full bg-[#3D3D3D] hover:bg-[#2D2D2D] disabled:opacity-60 disabled:hover:bg-[#3D3D3D] text-white py-3 rounded-full font-sans text-sm leading-none"
            >
              {submitting ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          <div className="mt-6 flex items-center justify-between">
            <Link to="/" className="font-sans text-sm text-[#3D3D3D]/70 hover:text-[#D4A5A5]">Back to site</Link>
            <div className="font-sans text-xs text-[#3D3D3D]/50">
              Tip: bootstrap the first admin in Swagger.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
